import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { modal } from '@/contexts'

import { walletProviderAtom } from './wallet'

export enum LoginStatus {
  initial = 'initial',
  walletWaitingSigning = 'walletWaitingSigning',
  emailConfirm = 'emailConfirm',
  login = 'login',
}

export const atomLoginStatus = atomWithStorage<LoginStatus>('loginStatus', LoginStatus.initial)

export const atomAccount = atom((get) => {
  const provider = get(walletProviderAtom)
  console.log('atomAccount', provider)

  if (!provider) return ''

  const address = modal.getAddress()

  return address
})

export const resetLoginStateAtom = atom(null, (_, set) => {
  console.log('Resetting login state')
  set(atomLoginStatus, LoginStatus.initial)
})

export const resetStateAtom = atom(null, (_, set) => {
  set(resetLoginStateAtom)
})
